import {
  AuthenticationDetails,
  CognitoUser,
  CognitoUserPool,
  CognitoUserAttribute,
} from 'amazon-cognito-identity-js';
import { userPoolId, appClientId } from '../config';

export const userPool = new CognitoUserPool({
  UserPoolId: userPoolId,
  ClientId: appClientId,
});

export const createUser = Username =>
  new CognitoUser({ Username, Pool: userPool });

export const createCredentials = (Username, Password) =>
  new AuthenticationDetails({ Username, Password });

export const getCurrentUser = () =>
  userPool.getCurrentUser();

function refreshSession({ success, error, user, session }) {
  user.refreshSession(
    session.getRefreshToken(),
    (err, refreshedSession) => {
      if (err) error(err);
      else success({ user, session: refreshedSession });
    });
}

export const getAuthenticatedUser = ({ success, error, minValidSeconds }) => {
  const user = getCurrentUser();

  if (!user) {
    const e = new Error('No current user');
    e.code = 'WXNotAuthenticated';
    error(e);
    return;
  }

  user.getSession((err, session) => {
    if (err) {
      return error(err);
    }

    if (minValidSeconds) {
      const expires = session.getAccessToken().getExpiration();
      const now = Math.floor(Date.now() / 1000);

      if (expires < now + minValidSeconds) {
        return refreshSession({ user, session, success, error });
      }
    }

    return success({ user, session });
  });
};

export const refreshCredentials = ({ success, error }) => {
  getAuthenticatedUser({
    error,
    success: ({ user, session }) =>
      refreshSession({ user, session, success, error }),
  });
};

export const userAttributesFromHash = hash =>
  Object.keys(hash).map(key =>
    new CognitoUserAttribute({ Name: key, Value: hash[key] }));

export const attributesToHash = (attrs) => {
  const hash = {};
  attrs.forEach((attr) => { hash[attr.Name] = attr.Value; });
  return hash;
};



// WEBPACK FOOTER //
// ./src/auth/cognito.js